var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('place-picker-map',{attrs:{"center":_vm.position,"options":_vm.options,"visible":_vm.isVisible,"marker-icon":_vm.markerIcon,"is-marker-visible":_vm.isMarkerVisible,"is-active":_vm.isActive,"marker-position":_vm.position},on:{"loaded":_vm.setPlacePickerLoaded,"click":_vm.handleMapClick,"mount":_vm.handleMapMount}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a7d5dbe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/PlacePicker/PlacePickerContainer.vue
// module id = null
// module chunks = 